export enum OrderStatus {
  NEW = 0,
  STARTED = 1,
  FINISHED = 4,
  CANCELLED = 5,
  FINISHING = 6,
}
